import { render, staticRenderFns } from "./RTab.vue?vue&type=template&id=893f3d5e"
import script from "./RTab.vue?vue&type=script&lang=js"
export * from "./RTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports